import React, { useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { AppContext } from '../../context/context';
import { getToken } from '../authentication/functions/authentication_management';
import type { DecodedAuthToken } from '../authentication/types/AuthTypes';

export default function CompanyRouteGuard({ children }: { children: React.ReactNode }) {
  const context = useContext(AppContext);
  const companyRole = context?.userData?.userDetails?.companyRole;

  const isCompanyAdmin = useMemo(() => {
    if (companyRole === 'company_admin') return true;
    const token = getToken();
    if (!token?.access_token) return false;
    try {
      const decoded = jwtDecode<DecodedAuthToken>(token.access_token);
      return decoded.company_role === 'company_admin';
    } catch {
      return false;
    }
  }, [companyRole]);

  if (!isCompanyAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
